import { defineMessages } from "./define.js";

/**
 * Теги: the picker, and the words for the palette a tag may be painted in.
 *
 * The colour names are interface, not content — a screen reader says them out
 * loud in place of a swatch nobody can see, so they follow the interface
 * language even though the tag's own name never does.
 */
export const tags = defineMessages("tags", {
  label: { ru: "Теги", en: "Tags" },
  group: { ru: "Теги: {label}", en: "Tags: {label}" },
  edit: { ru: "Изменить теги: {label}", en: "Edit tags: {label}" },
  name: { ru: "Название тега", en: "Tag name" },
  find: { ru: "Найти или создать тег", en: "Find or create a tag" },
  add: { ru: "Добавить тег «{name}»", en: "Add tag “{name}”" },
  remove: { ru: "Убрать тег «{name}»", en: "Remove tag “{name}”" },
  create: { ru: "Создать «{name}»", en: "Create “{name}”" },
  newColor: { ru: "Цвет нового тега", en: "New tag colour" },
  color: { ru: "Цвет: {color}", en: "Colour: {color}" },
  already: { ru: "Тег «{name}» уже здесь.", en: "Tag “{name}” is already here." },
  none: {
    ru: "Тегов пока нет — начните печатать, чтобы создать первый.",
    en: "No tags yet — start typing to create the first one.",
  },
  all: { ru: "Все теги уже здесь.", en: "All tags are already here." },
  done: { ru: "Готово", en: "Done" },

  colorAccent: { ru: "янтарный", en: "amber" },
  colorDeep: { ru: "насыщенный", en: "solid" },
  colorWarn: { ru: "зелёный", en: "green" },
  colorNeg: { ru: "розовый", en: "rose" },
  colorNeutral: { ru: "серый", en: "grey" },
  colorPlain: { ru: "без заливки", en: "outline" },
});
